var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnergy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "18px",
    viewBox: "0 0 24 18",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "energy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.50495 15L0.50045 15C0.224202 15 0 14.776 0 14.5C0 14.224 0.224202 14 0.50045 14L5.50495 14C6.3327 14 7.00631 13.327 7.00631 12.5L7.00631 11.5C7.00631 11.224 7.23051 11 7.50676 11L8.49865 11C8.7749 11 8.9991 10.776 8.9991 10.5L8.9991 4.5C8.9991 4.224 8.7749 4 8.49865 4L7.50676 4C7.23051 4 7.00631 3.776 7.00631 3.5L7.00631 2.5C7.00631 1.673 6.3327 1 5.50495 1L2.50225 1C2.226 1 2.0018 0.776 2.0018 0.5C2.0018 0.224 2.226 0 2.50225 0L5.50495 0C6.8842 0 8.00721 1.122 8.00721 2.5L8.00721 3L8.49865 3C9.32639 3 10 3.673 10 4.5L10 10.5C10 11.327 9.32639 12 8.49865 12L8.00721 12L8.00721 12.5C8.00721 13.878 6.8842 15 5.50495 15Z",
    transform: "translate(14 1)",
    id: "Shape",
    fill: "#333333",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 15L2.5 15C1.122 15 0 13.878 0 12.5L0 2.5C0 1.122 1.122 0 2.5 0L9.5 0C9.776 0 10 0.224 10 0.5C10 0.776 9.776 1 9.5 1L2.5 1C1.673 1 1 1.673 1 2.5L1 12.5C1 13.327 1.673 14 2.5 14L6.5 14C6.776 14 7 14.224 7 14.5C7 14.776 6.776 15 6.5 15Z",
    transform: "translate(0 1)",
    id: "Shape",
    fill: "#333333",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.80294 18C2.72394 18 2.64294 17.981 2.56894 17.942C2.35394 17.828 2.25194 17.575 2.32894 17.343L4.42294 10.9996L0.499944 10.9996C0.313944 10.9996 0.143945 10.8966 0.0569445 10.7316C-0.0290554 10.5666 -0.0170554 10.3676 0.0889445 10.2146L7.01494 0.214062C7.15094 0.018052 7.40994 -0.0519517 7.62594 0.0400532C7.84494 0.136058 7.96594 0.373071 7.91494 0.606083L6.50694 6.99942L10.4999 6.99942C10.6899 6.99942 10.8639 7.10743 10.9489 7.27843C11.0329 7.44944 11.0119 7.65345 10.8959 7.80446L3.19894 17.805C3.10194 17.932 2.95394 18 2.80294 18ZM1.45494 9.99958L5.11494 9.99958C5.27594 9.99958 5.42594 10.0766 5.51994 10.2066C5.61394 10.3366 5.63994 10.5036 5.58894 10.6566L4.19894 14.8658L9.48394 7.99947L5.88494 7.99947C5.73394 7.99947 5.58994 7.93047 5.49494 7.81246C5.39994 7.69446 5.36394 7.53945 5.39594 7.39144L6.39194 2.8702L1.45494 9.99958Z",
    transform: "translate(7 0)",
    id: "Shape",
    fill: "#333333",
    stroke: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.bdec525bd507c02d273083350e271b6c.svg";
export { ForwardRef as ReactComponent };